export default "__VITE_ASSET__DkWFp1It__"